import { CountUpOnView } from "./ui/count-up-view";

export function SummaryHome() {
  return (
    <section className="py-20 bg-gradient-to-br from-violet-600 to-purple-700 text-white">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="text-center mb-14">
          <span className="text-sm font-semibold tracking-widest text-violet-200 uppercase mb-3 block">
            Impacto
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 leading-tight">
            Números que hablan
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="text-5xl font-bold mb-2">+<CountUpOnView end={1100} /></div>
            <div className="text-purple-200 text-sm">Abogados verificados</div>
          </div>
          <div className="text-center">
            <div className="text-5xl font-bold mb-2">+<CountUpOnView end={3500} /></div>
            <div className="text-purple-200 text-sm">Casos publicados</div>
          </div>
          <div className="text-center col-span-2 md:col-span-1">
            <div className="text-5xl font-bold mb-2 flex items-baseline justify-center gap-0.5">
              <CountUpOnView end={86} />
              <span className="text-[0.75em] align-baseline">%</span>
            </div>
            <div className="text-purple-200 text-sm">Reciben múltiples propuestas</div>
          </div>
        </div>
      </div>
    </section>
  );
}